import { useTranslation } from 'react-i18next';

import { cn } from '../lib/cn';

interface LanguagePillSwitcherProps {
  className?: string;
}

export function LanguagePillSwitcher({ className }: LanguagePillSwitcherProps) {
  const { i18n } = useTranslation();

  const languages: Array<{ value: string; label: string; title: string }> = [
    { value: 'en', label: 'EN', title: 'Switch to English' },
    { value: 'pap', label: 'PAP', title: 'Kambia pa Papiamentu' },
  ];

  return (
    <div className={cn('flex w-fit bg-muted/30 rounded-full p-1', className)}>
      {languages.map(({ value, label, title }) => (
        <button
          key={value}
          onClick={() => {
            void i18n.changeLanguage(value);
          }}
          className={cn(
            'px-4 py-1.5 rounded-full text-xs font-semibold transition-all uppercase tracking-wide',
            i18n.language === value
              ? 'bg-primary text-primary-foreground shadow-md'
              : 'text-foreground hover:text-primary',
          )}
          title={title}
          type="button"
        >
          {label}
        </button>
      ))}
    </div>
  );
}
